/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./deleteGate.defs.js";
export { main as default } from "./deleteGate.defs.js";
